import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "mt-6"
}

import { computed, PropType } from 'vue';
import SmartFormSummaryItem from './SmartFormSummaryItem.vue';
import { FormSection } from '@/models';
import { i18n } from '@/i18n/i18n';
import { useSmartFormStore } from '@/stores/smartForm.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartFormSummarySection',
  props: {
  section: {
    type: Object as PropType<FormSection>,
    required: true
  },

  patientId: {
    type: String,
    default: null
  },

  participantId: {
    type: String,
    default: null
  },

  formSubmissionId: {
    type: String,
    required: true
  },

  level: {
    type: Number,
    default: 0
  },

  locale: {
    type: String,
    default: i18n.global.locale.value
  }
},
  setup(__props) {

const props = __props;



const smartForm = useSmartFormStore();

const conditionsMet = computed(() => smartForm.getItemConditionsMet(props.formSubmissionId, props.section.conditions));

return (_ctx: any,_cache: any) => {
  const _component_SmartFormSummarySection = _resolveComponent("SmartFormSummarySection", true)!

  return (_unref(conditionsMet))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent('h' + (__props.level + 2)), {
          class: _normalizeClass(["font-bold text-gray-900 text-xl leading-tight", { 'mt-8': __props.level > 0 }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.section.heading), 1)
          ]),
          _: 1
        }, 8, ["class"])),
        (__props.level > 0)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_2))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.items, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            (item.type === 'section')
              ? (_openBlock(), _createBlock(_component_SmartFormSummarySection, {
                  key: 0,
                  section: item,
                  "patient-id": __props.patientId,
                  "participant-id": __props.participantId,
                  "form-submission-id": __props.formSubmissionId,
                  locale: __props.locale,
                  level: __props.level + 1
                }, null, 8, ["section", "patient-id", "participant-id", "form-submission-id", "locale", "level"]))
              : (_openBlock(), _createBlock(SmartFormSummaryItem, {
                  key: item.id,
                  item: item,
                  "patient-id": __props.patientId,
                  "participant-id": __props.participantId,
                  "form-submission-id": __props.formSubmissionId,
                  locale: __props.locale,
                  class: "mt-8"
                }, null, 8, ["item", "patient-id", "participant-id", "form-submission-id", "locale"]))
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})